import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
export function Contact() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setFormStatus('submitting');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 4000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 4000);
      }
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 4000);
    }
  };
  return <section id="contact" className="py-24 bg-[#0A0A0F] relative" data-id="element-51" data-mp="3jv2uuwrvh61c">
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-52" data-mp="3ouece802cfjz"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-53" data-mp="3b2hs2q4mz9y5">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-54" data-mp="3f4cnxf3ssv4j">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-55" data-mp="315d2egbl0wcl">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-56" data-mp="2s5q9kiwx4yv5">
              Let's Build Something{' '}
              <span className="text-gradient" data-id="element-57" data-mp="2w835ygprzkf9">Amazing</span>
            </h2>
            <p className="text-lg mb-10 text-[#FFFFFF]" data-id="element-58" data-mp="qdjyatzwm3hh">
              Ready to elevate your online presence? Fill out the form or reach
              out directly. I usually respond within a few hours.
            </p>

            <div className="space-y-8 mb-12" data-id="element-59" data-mp="239hhvniuslud">
              <div data-id="element-60" data-mp="1yc7u0cb44i8n">
                <p className="text-xl font-bold text-white" data-id="element-61" data-mp="1ybpr4wty35rr">Mike</p>
                <p className="text-white text-sm mb-5" data-id="element-62" data-mp="1uadva9kh9ob4">
                  Owner and Web Designer
                </p>
                <div className="space-y-4" data-id="element-63" data-mp="1pcujrhf5zpmv">
                  <a href="tel:818-381-9905" className="flex items-center gap-4 group" data-id="element-64" data-mp="1pdvxxurh8s8t">
                    <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-colors border border-blue-500/20" data-id="element-65" data-mp="2m1a7r92mlqxv">
                      <Phone size={18} data-id="element-66" data-mp="2d7f3s4d8q6jt" />
                    </div>
                    <span className="text-lg font-semibold text-white" data-id="element-67" data-mp="289vn6xt2lhop">
                      818-381-9905
                    </span>
                  </a>
                  <a href="mailto:mikesproweb@gmail.com" className="flex items-center gap-4 group" data-id="element-68" data-mp="30zm57hxtp3q3">
                    <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-colors border border-blue-500/20" data-id="element-69" data-mp="38aqsyz6mwaen">
                      <Mail size={18} data-id="element-70" data-mp="3i8f06olffadp" />
                    </div>
                    <span className="text-lg font-semibold text-white break-all" data-id="element-71" data-mp="3ib166jso5htt">
                      mikesproweb@gmail.com
                    </span>
                  </a>
                </div>
              </div>

              <div className="pt-8 border-t border-white/10" data-id="element-72" data-mp="2s7b6j4pfrc">
                <p className="text-xl font-bold text-white" data-id="element-73" data-mp="17fhoo78ax6">Brian </p>
                <p className="text-white text-sm mb-5" data-id="element-74" data-mp="4uth8lstque7">
                  Senior Client Advisor
                </p>
                <div className="space-y-4" data-id="element-75" data-mp="9sbtal251pqf">
                  <a href="tel:818-646-6534" className="flex items-center gap-4 group" data-id="element-76" data-mp="duqal0q5shfl">
                    <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-colors border border-blue-500/20" data-id="element-77" data-mp="itjd5y3wqo0z">
                      <Phone size={18} data-id="element-78" data-mp="15h70t7q9rgp" />
                    </div>
                    <span className="text-lg font-semibold text-white" data-id="element-79" data-mp="134tqtcx059z">
                      818-646-6534
                    </span>
                  </a>
                  <a href="mailto:brian.mikesproweb@gmail.com" className="flex items-center gap-4 group" data-id="element-80" data-mp="9x9f4x9a4oi4">
                    <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-400 group-hover:bg-blue-600 group-hover:text-white transition-colors border border-blue-500/20" data-id="element-81" data-mp="3iedx359l2vn4">
                      <Mail size={18} data-id="element-82" data-mp="3scbpm4yh7elj" />
                    </div>
                    <span className="text-lg font-semibold text-white break-all" data-id="element-83" data-mp="3nbw9j5mt7szv">
                      brian.mikesproweb@gmail.com
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-84" data-mp="12loq98paimo6">
              <a href="tel:818-381-9905" className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors shadow-md" data-id="element-85" data-mp="2kjtiahtv22yn">
                Call Now
              </a>
              <a href="mailto:mikesproweb@gmail.com" className="px-6 py-3 rounded-lg bg-white/5 hover:bg-white/10 text-white border border-white/10 font-medium transition-colors" data-id="element-86" data-mp="2bj551pcak6mt">
                Send Email
              </a>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#111118] border border-white/5 rounded-3xl p-8 md:p-10 shadow-2xl" data-id="element-87" data-mp="389ec5vrjykmp">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-88" data-mp="3n652zgn5uo0p">
              Request a Free Consultation
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-89" data-mp="3ry6olt67xr3e">
              <input type="hidden" name="access_key" value="c10950f6-01a1-4871-8cc0-569baf2fe57f" data-id="element-90" data-mp="5npuydvj99p3" />
              <input type="hidden" name="subject" value="New Website Inquiry from Mike's Pro Web Design" data-id="element-91" data-mp="od5rmh6vqjc" />
              <input type="hidden" name="from_name" value="Mike's Pro Web Design" data-id="element-92" data-mp="3ruo9jqdl35ed" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-93" data-mp="3mwd1nl6un4ys">
                <div data-id="element-94" data-mp="3my7bo4gl1co3">
                  <label htmlFor="contact-name" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-95" data-mp="3iuj77un8yx72">
                    Full Name
                  </label>
                  <input id="contact-name" type="text" name="name" required className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="John Doe" data-id="element-96" data-mp="3e2hvc9tzr8hk" />
                </div>
                <div data-id="element-97" data-mp="2z60itfa2fntf">
                  <label htmlFor="contact-email" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-98" data-mp="2z8d1xvrk8482">
                    Email Address
                  </label>
                  <input id="contact-email" type="email" name="email" required className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="john@example.com" data-id="element-99" data-mp="1amcwxlgryap1" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-100" data-mp="1okky65kufy60">
                <div data-id="element-101" data-mp="r089twov99re">
                  <label htmlFor="contact-phone" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-102" data-mp="qwu4qgotimg9">
                    Phone Number
                  </label>
                  <input id="contact-phone" type="tel" name="phone" className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="(555) 123-4567" data-id="element-103" data-mp="10wb7ap8rwk80" />
                </div>
                <div data-id="element-104" data-mp="d6gxkgjr3brz">
                  <label htmlFor="contact-business" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-105" data-mp="d5xm9iolvlmx">
                    Business Name
                  </label>
                  <input id="contact-business" type="text" name="business" className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all" placeholder="Your Company LLC" data-id="element-106" data-mp="2xrixvv6m6zf8" />
                </div>
              </div>

              <div data-id="element-107" data-mp="3lmvdvu279g2z">
                <label htmlFor="contact-message" className="block text-sm font-medium mb-2 text-[#FFFFFF]" data-id="element-108" data-mp="3lmbu07szohmb">
                  Project Details
                </label>
                <textarea id="contact-message" name="message" required rows={4} className="w-full bg-black border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all resize-none" placeholder="Tell me about your business and what you're looking to build..." data-id="element-109" data-mp="3ufgje8gtlq9v"></textarea>
              </div>

              <button type="submit" disabled={formStatus === 'submitting'} className="w-full py-4 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white font-bold text-lg hover:shadow-[0_0_20px_rgba(59,130,246,0.3)] transition-all flex items-center justify-center gap-2 disabled:opacity-70" data-id="element-110" data-mp="mvpeyzgfkoif">
                {(formStatus === 'idle' || formStatus === 'error') && <>
                    Get My Free Quote <Send size={20} data-id="element-111" data-mp="457lgsnrxow0" />
                  </>}
                {formStatus === 'submitting' && 'Sending...'}
                {formStatus === 'success' && 'Message Sent!'}
              </button>

              {formStatus === 'success' && <p className="text-sm text-green-400 text-center" role="status" data-id="element-112" data-mp="3qeacxclpbtxp">
                  Thanks! Your message has been sent — I'll be in touch shortly.
                </p>}
              {formStatus === 'error' && <p className="text-sm text-red-400 text-center" role="alert" data-id="element-113" data-mp="3hcswft4dtq8h">
                  Something went wrong. Please try again or email me directly.
                </p>}
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}